const list = {
  path: 'withdrawlist',
  component: resolve => require(['@/pages/admin/finance/withdrawlist'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list
